module.exports = __webpack_public_path__ + "static/media/banner19.bf22ceda.png";